import React from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";

import AppShellSkeleton from "src/components/AppShellSkeleton/AppShellSkeleton";
import useTimeout from "src/hooks/useTimeout";

const TEN_MINUTES = 600000;

const WorkspaceChallengeLoading = ({
  timeout = parseInt(process.env.REACT_APP_LOADING_DEFAULT_TIMEOUT, 10) ||
    TEN_MINUTES,
  waitingFor,
}) => {
  const location = useLocation();

  useTimeout(() => {
    throw new Error(
      `timed out after ${timeout} millisecs, loading: '${waitingFor}', path: '${location.pathname}'`
    );
  }, timeout);

  return (
    <AppShellSkeleton
      data-testid="workspace-challenge-shell-skeleton"
      aria-label="Loading workspace"
      statusMessage="Loading context..."
    />
  );
};

WorkspaceChallengeLoading.propTypes = {
  timeout: PropTypes.number,
  waitingFor: PropTypes.string.isRequired,
};

export default WorkspaceChallengeLoading;
